// Time zone of the agent's phone-availability slots, as written to the device twin
// (desired.phoneAvailability.timezone) and read by the backend when it decides whether to
// transfer a call to the agent's phone.
//
// The value is an IANA zone id, never a fixed UTC offset: an offset has no daylight-saving
// rule, so "UTC-05:00" is wrong for Québec from March to November and agents had to pick
// "Atlantic" to get their slots honoured. Only the two zones the product serves are offered.

export const QUEBEC_TIMEZONE = 'America/Toronto'
export const MADELEINE_TIMEZONE = 'America/Halifax'

// Ordered as displayed; `labelKey` is resolved through vue-i18n by the component.
export const PHONE_TIMEZONES = [
  { value: QUEBEC_TIMEZONE, labelKey: 'call.timezones.quebec' },
  { value: MADELEINE_TIMEZONE, labelKey: 'call.timezones.madeleine' },
]

export const DEFAULT_PHONE_TIMEZONE = QUEBEC_TIMEZONE

/**
 * Maps whatever the device twin holds to one of the offered zones.
 * Legacy fixed offsets ("UTC-05:00", "UTC-04:00") and unset values fall back to Québec: an
 * agent who chose "Atlantic" did so to compensate the missing DST rule, not because they are in
 * the Atlantic zone. The corrected value is written back at the agent's next phone-settings save.
 */
export function resolvePhoneTimezone(stored) {
  const known = PHONE_TIMEZONES.find(option => option.value === stored)
  return known ? known.value : DEFAULT_PHONE_TIMEZONE
}
